import { Modal } from 'antd';
import { useState, useEffect, useRef } from 'react';
import {
  array, bool, func, number,
} from 'prop-types';

import ImagesSlider from 'components/imagesSlider';

import { dataLayerHandleEvent } from 'utils/dataLayers';

import styles from './style.module.css';

export function ModalZoomImg({
  visible, handleCloseZoom, images, initIndex,
}) {
  const imagesWithoutVideo = images.filter((image) => !image?.isVideo);
  const [ imageIndex, setImageIndex ] = useState(initIndex);
  const previousImageIndex = useRef(imageIndex);

  useEffect(() => {
    setImageIndex(initIndex);
    previousImageIndex.current = initIndex;
  }, [ initIndex ]);

  useEffect(() => {
    const { current } = previousImageIndex;

    if (current !== imageIndex) {
      const mode = imageIndex > current ? 'next' : 'back';

      dataLayerHandleEvent({
        event: 'item_photos',
        event_category: 'product detail',
        event_detail_1: mode,
        event_detail_2: imagesWithoutVideo[current]?.md,
      });
    }

    previousImageIndex.current = imageIndex;
  }, [ imageIndex ]);

  return (
    <Modal
      className={styles.fullModal}
      width={'100%'}
      title={null}
      visible={visible}
      closable={false}
      destroyOnClose={true}
      onCancel={handleCloseZoom}
      footer={null}
      style={{
        height: '100%',
      }}
      wrapClassName={styles.wrapModal}
    >
      <>
        <span onClick={() => handleCloseZoom(imagesWithoutVideo[previousImageIndex.current])} className={`${styles.zoomImgClose} ${styles.zoomImgSpan}`}>✕</span>
        <div
          id="fullscreenContainer"
        >
          {visible ?
            <ImagesSlider
              setImageIndex={setImageIndex}
              images={imagesWithoutVideo}
              initIndex={initIndex}
            /> :
            null
          }
        </div>
      </>
    </Modal>
  );
}

ModalZoomImg.defaultProps = {
  images: [],
  visible: false,
  handleCloseZoom: () => true,
  initIndex: 0,
};

ModalZoomImg.propTypes = {
  images: array,
  visible: bool,
  handleCloseZoom: func,
  initIndex: number,
};

export default ModalZoomImg;
